import { useLocation } from 'react-router-dom';

import {
  appendReferer,
  useOperationalEvent,
  usePageViewedEvent,
} from '../../../utilities/analytics/analytics-web-client';
import {
  isAppleAuthEnabled,
  isMicrosoftAuthEnabled,
  isSlackAuthEnabled,
} from '../../../utilities/social-login';

import { pageId } from '../constants';
import { useAppendReasonViewingScreen } from './utility';

export const useLoginPageViewed = () => {
  const location = useLocation();

  // Check which social login options are being shown
  const isMicrosoftButtonEnabled = isMicrosoftAuthEnabled(location);
  const isAppleButtonEnabled = isAppleAuthEnabled(location);
  const isSlackButtonEnabled = isSlackAuthEnabled(location);

  const queryParams = new URLSearchParams(location.search);

  const appendReasonViewingScreen = useAppendReasonViewingScreen();

  usePageViewedEvent(pageId, {
    ...appendReferer(
      appendReasonViewingScreen({
        isMicrosoftButtonEnabled,
        isAppleButtonEnabled,
        isSlackButtonEnabled,
      })
    ),
    noAccess: !!queryParams.get('tenant'),
  });

  useOperationalEvent({
    page: pageId,
    action: 'loadLoginPageSuccessful',
    subject: 'sli',
  });
};
